import TwoColumnLayout from "layout/TwoColumnLayout";
import { useLoaderData } from "react-router";
import React from "react";
import { TrainDetailSection } from "train/TrainDetailSection";
import TrainOptionsPanel from "train/TrainOptionsPanel";
import { TrainActivityPanel } from "./activity/TrainActivityPanel";
import { TrainItinerarySidebarApp } from "show/ItinerarySidebar/app";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { useIsInternal } from "common/SessionContext";

export const TrainDetailApp = () => {
  const isInternal = useIsInternal();
  const viewModel = useLoaderData<server.viewmodel.TrainDetailFrontModel>();
  const [artist, setArtist] = React.useState<server.dto.ArtistSmall>(viewModel.sidePanelDto.train.artist);
  const [appointmentDateTime, setAppointmentDateTime] = React.useState<server.dto.AppointmentDateTime>(viewModel.sidePanelDto.train.dateTime);
  const [queryKey, setQueryKey] = React.useState<number>(0);

  const linkedShowsQuery = useQuery({
    queryKey: ["linkedShowsToFlight", viewModel.sidePanelDto.train.trainId],
    queryFn: async () => {
      const result = await window.CoreApi.Train.GetSidePanelData(viewModel.sidePanelDto.train.trainId);
      return result.data.data?.linkedShows ?? [];
    },
    initialData: viewModel.sidePanelDto.linkedShows,
    initialDataUpdatedAt: Date.now(),
    staleTime: Infinity,
  });

  const linkedShowsData = linkedShowsQuery.data ?? [];
  const refetchLinkedShows = async () => {
    await linkedShowsQuery.refetch();
    setQueryKey(prev => prev + 1);
  };

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TrainDetailSection
        train={viewModel.sidePanelDto.train}
        linkedShows={linkedShowsData}
        linkShowToTravel={{
          canLink: viewModel.sidePanelDto.train.permissions.canModify,
          travelType: "train",
          travelId: viewModel.sidePanelDto.train.trainId,
          appointmentDateTime,
          artist,
          linkedShowIds: linkedShowsData.map(show => show.showId),
          onLinked: refetchLinkedShows
        }}
        travellers={viewModel.sidePanelDto.passengers}
        files={viewModel.sidePanelDto.files}
        onArtistChanged={a => setArtist(a)}
        onStatusChanged={() => setQueryKey(prev => prev + 1)}
        onDateChanged={d => {
          setAppointmentDateTime(d)
          setQueryKey(prev => prev + 1);
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <TrainOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        trainId={viewModel.sidePanelDto.train.trainId}
      />
      {isInternal && <TrainItinerarySidebarApp
        trainId={viewModel.sidePanelDto.train.trainId}
        artist={artist}
        startDate={moment.utc(appointmentDateTime.startDisplay)}
        endDate={moment.utc(appointmentDateTime.endDisplay)}
        linkedShowIds={linkedShowsData.map(ls => ls.showId)}
        queryKeys={`TrainItinerary-${queryKey}`}
      />}
      {isInternal && <TrainActivityPanel
        config={viewModel.activityPanelConfig}
        trainId={viewModel.sidePanelDto.train.trainId}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}
